import { api } from './client';
import type { HandlingRevision } from '../types';

export const vehicleHandlingApi = {
  list: (vehicleId: number) =>
    api.get<{ revisions: HandlingRevision[] }>(`/vehicles/${vehicleId}/handling`),

  latest: (vehicleId: number) =>
    api.get<{ revision: HandlingRevision | null }>(`/vehicles/${vehicleId}/handling/latest`),

  create: (vehicleId: number, data: { handling_xml: string; change_note: string }) =>
    api.post<{ revision: HandlingRevision }>(`/vehicles/${vehicleId}/handling`, data),

  delete: (vehicleId: number, revisionId: number) =>
    api.delete<{ success: boolean }>(`/vehicles/${vehicleId}/handling/${revisionId}`),
};
